import React from "react";
import { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Heartsvg from "./heart-regular.svg";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
export default class Heart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            liked: true,
        };
        this.toggleLike = () => {
            this.setState((state) => ({
                liked: !state.liked,
            }));
        };
    }
    render() {
        console.log("heart");
        return (
            <div onClick={this.toggleLike} className="heart">
                {this.state.liked ? (
                    <img className="Heart-image" src={Heartsvg} alt="" />
                ) : (
                    <FontAwesomeIcon
                        className="Heart-font"
                        style={{ fontSize: "23px" }}
                        icon={faHeart}
                    />
                )}
            </div>
        );
    }
}
